import { HORIZONTAL_SCROLL_SELECTOR } from '../../constants';

/**
 * Embla タブ切替と横スクロール棚のジェスチャ調停。
 *
 * - pointerdown: 横スクロール可能な [data-horizontal-scroll] 内では Embla drag を開始しない
 * - 横スクロール不能（件数少）: drag 許可でタブ切替
 * - Pickups / ヤリカノも同じ判定（旧: ID 子孫は無条件 drag 禁止 → 新: スクロール可能時のみ禁止）
 */
const SCROLLABLE_WIDTH_THRESHOLD = 1;

export function isHorizontallyScrollable(element: Element): boolean {
  return (
    element.scrollWidth > element.clientWidth + SCROLLABLE_WIDTH_THRESHOLD
  );
}

export function shouldStartShelfDrag(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) {
    return true;
  }

  const scrollContainer = target.closest(HORIZONTAL_SCROLL_SELECTOR);
  if (!scrollContainer) {
    return true;
  }

  return !isHorizontallyScrollable(scrollContainer);
}
